export function titleize(str: string, splitOn: string = ' '): string {
  return str
    .toLowerCase()
    .split(splitOn)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function removeAccents(label: string): string {
  return label.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function sortRecordsByLabel<T extends { escapedValue: string }>(
  list: T[],
): T[] {
  return list.sort((a, b) => {
    const aLabel = removeAccents(a.escapedValue.toLowerCase());
    const bLabel = removeAccents(b.escapedValue.toLowerCase());
    return aLabel.localeCompare(bLabel);
  });
}
